module.exports = __webpack_public_path__ + "img/attraction-2-old.79da011b.jpg";